import { render, staticRenderFns } from "./SinisterPackages.vue?vue&type=template&id=09d409aa&scoped=true"
import script from "./SinisterPackages.vue?vue&type=script&lang=js"
export * from "./SinisterPackages.vue?vue&type=script&lang=js"
import style0 from "./SinisterPackages.vue?vue&type=style&index=0&id=09d409aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d409aa",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/SinisterPackages.vue
// module id = 2067
// module chunks = 31